import React from 'react';
import { Text, Flex, Heading, Link as ChakraLink, Button } from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import AleaChoiceStatus from '../AleaChoiceStatus/AleaChoiceStatus.tsx';
import { StatusType } from '../../constants/statusColors.ts';
import AleaArchiveIcon from '../../icons/AleaArchiveIcon.tsx';

interface FormHeaderProps {
  title: string;
  redirectUrl?: string;
  variant?: 'card' | 'plain';
  isStatus?: boolean;
  stateName?: StatusType;
  onStatusChange?: (newStatus: StatusType) => void;
  actionButton?: {
    icon?: React.ReactNode;
    label?: string;
    onClick: () => void;
    isRestore?: boolean;
  };
  canEdit?: boolean;
}

const FormHeader: React.FC<FormHeaderProps> = ({
  title,
  redirectUrl,
  variant = 'card',
  isStatus,
  stateName,
  onStatusChange,
  actionButton,
  canEdit = true,
}) => {
  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      mb={3}
      bg={variant === 'card' ? 'white' : 'transparent'}
      borderRadius={variant === 'card' ? '20px' : '0'}
      h={variant === 'card' ? '75' : 'auto'}
    >
      <Heading size="lg" fontSize={25} fontWeight={500}>
        <Flex alignItems="center">
          {redirectUrl ? (
            <Flex w={75} justifyContent="center" alignItems="center">
              <ChakraLink as={ReactRouterLink} to={redirectUrl}>
                <ChevronLeftIcon />
              </ChakraLink>
            </Flex>
          ) : null}
          <Flex fontSize={24} fontWeight={400}>
            <Text
              maxW="100%"
              overflow="hidden"
              textOverflow="ellipsis"
              display="-webkit-box"
              sx={{
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {title}
            </Text>

            {isStatus && canEdit && (
              <AleaChoiceStatus
                stateName={stateName as StatusType}
                onStatusChange={onStatusChange}
                residentName={title}
              />
            )}
          </Flex>
        </Flex>
      </Heading>

      {actionButton && canEdit && (
        <Button
          colorScheme="alea"
          variant={actionButton.isRestore ? "solid" : "outline"}
          size="lg"
          onClick={actionButton.onClick}
          borderRadius="20px"
          mr={4}
          h="50px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg={actionButton.isRestore ? "alea.500" : "transparent"}
          borderColor={actionButton.isRestore ? "alea.500" : "sunsetEmber.500"}
          color={actionButton.isRestore ? "white" : "sunsetEmber.500"}
          _hover={{
            bg: actionButton.isRestore ? "alea.600" : "#fbfbfb",
            borderColor: actionButton.isRestore ? "alea.600" : "sunsetEmber.500"
          }}
          px={actionButton.label ? "16px" : "10px"}
        >
          {actionButton.icon || <AleaArchiveIcon size="22" />}
          {actionButton.label && (
            <Text 
              ml={2} 
              fontWeight={400} 
              color={actionButton.isRestore ? "white" : "sunsetEmber.500"}
            >
              {actionButton.label}
            </Text>
          )}          
        </Button>
      )}
    </Flex>
  );
};

export default FormHeader;
